module.exports = __webpack_public_path__ + "static/hackathon-game-9eaa46c9e447709656284491124bd95a.jpg";